module.exports = __webpack_public_path__ + "static/media/D-stats-1024.0e88b164.png";